import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import {} from 'react';
import { Toaster } from '..';
import { useMediaQuery } from '../../utils';
import { createPortal } from '../../utils/portal';
export const SCAFFOLD_WIDE_VIEW_MEDIA_SELECTOR = '@media(min-width: 1024px)';
const breakpointToCss = (breakpoint) => css({
    display: breakpoint === 'narrow' ? 'revert' : breakpoint === 'wide' ? 'none' : undefined,
    [SCAFFOLD_WIDE_VIEW_MEDIA_SELECTOR]: {
        display: breakpoint === 'wide' ? 'revert' : breakpoint === 'narrow' ? 'none' : undefined,
    },
});
const [FabPortalProvider, FabPortal, FabPortalElement] = createPortal();
const Scaffold = (props) => (_jsxs("div", { css: [
        css `
        min-height: 100vh;
        /* Avoid Chrome seeing the hack */
        @supports (-webkit-touch-callout: none) {
          body {
            /* The hack for Safari */
            height: -webkit-fill-available;
          }
        }
      `,
        {
            [SCAFFOLD_WIDE_VIEW_MEDIA_SELECTOR]: {
                display: 'grid',
                gap: '4.8rem',
                gridTemplateColumns: 'min-content 1fr',
                gridTemplateAreas: `
            'side   main'
            'side   main'
            'side footer'
          `,
            },
        },
    ], children: [_jsx("div", { css: [
                {
                    position: 'sticky',
                    top: 0,
                    right: 0,
                    left: 0,
                    zIndex: 1,
                },
                breakpointToCss(props.breakpoints?.topBar),
            ], children: props.topBar }), _jsx("div", { css: [{ gridArea: 'side' }, breakpointToCss(props.breakpoints?.sideBar)], children: _jsx("div", { css: css `
          position: sticky;
          top: 0;
          padding: 2.4rem;
          height: 100vh; /* fallback for devices which don't support dvh */
          height: 100dvh; /* fixes height on iOS safari (uses the viewport height - i.e. excludes the area covered by browser UI elements) */
        `, children: props.sideBar }) }), _jsx("main", { css: {
                gridArea: 'main',
                position: 'relative',
                padding: '2.4rem 2.4rem 10rem 2.4rem',
                [SCAFFOLD_WIDE_VIEW_MEDIA_SELECTOR]: { paddingBottom: 0, paddingLeft: 0 },
            }, children: _jsxs(FabPortalProvider, { children: [props.children, _jsx("div", { css: {
                            position: 'sticky',
                            // Take into account fixed bottom bar
                            bottom: 'calc(2.4rem + 8rem)',
                            width: 'max-content',
                            marginLeft: 'auto',
                            [SCAFFOLD_WIDE_VIEW_MEDIA_SELECTOR]: {
                                bottom: '2.4rem',
                            },
                            ':empty': { display: 'none' },
                        }, children: props.floatingActionButton || _jsx(FabPortalElement, {}) })] }) }), _jsx("div", { css: [{ position: 'fixed', right: 0, bottom: 0, left: 0 }, breakpointToCss(props.breakpoints?.bottomBar)], children: props.bottomBar }), _jsx("footer", { css: [
                {
                    gridArea: 'footer',
                    alignSelf: 'end',
                },
                breakpointToCss(props.breakpoints?.footer),
            ], children: props.footer }), _jsx("div", { css: breakpointToCss(props.breakpoints?.drawer), children: props.drawer }), _jsx(Toaster, { position: useMediaQuery(SCAFFOLD_WIDE_VIEW_MEDIA_SELECTOR) ? 'top-right' : 'top-center', css: { zIndex: 2 } })] }));
export const FloatingActionButtonPortal = FabPortal;
export default Scaffold;
//# sourceMappingURL=Scaffold.js.map